// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"740":"dff412f0","847":"10dba161"}[chunkId] + ".js";
};